import { common } from '../common'

const Analytics = {
  send: (eventCategory, eventAction, eventLabel) => {
    var labels = ''
    if (typeof eventLabel === 'object') {
      const customKeys = Object.keys(eventLabel || {})
      labels = customKeys.reduce((accumulator, key) => {
        accumulator = accumulator + `${key}: ${eventLabel[key]}, `
        return accumulator
      }, '')
      labels = labels.substring(0, labels.length - 2)
    }

    common.getGATokens()
      .then((tokens) => {
        tokens.forEach((token) => {
          window.ga(`${token}.send`, 'event', eventCategory, eventAction, labels)
        })
      })
      .catch(() => {})
  }
}

export default Analytics
